import { createSlice } from '@reduxjs/toolkit'

export const commentsSlice = createSlice({
    name: 'comments',
    initialState: {
        items: {}, //comments
        likes: {},
        hasMore: false,
        lastEvaluatedKey: null
    },
    reducers: {
        setComments: (state, action) => {
            state.items[action.payload.postId] = action.payload.comments
            state.hasMore = action.payload.hasMore
            state.lastEvaluatedKey = action.payload.lastEvaluatedKey
        },
        appendComments: (state, action) => {
            state.items[action.payload.postId] = state.items[action.payload.postId].concat(action.payload.comments ?? [])
            state.hasMore = action.payload.hasMore
            state.lastEvaluatedKey = action.payload.lastEvaluatedKey
        },
        insertComment: (state, action) => {
            state.items[action.payload.postId] = [action.payload.comment, ...state.items[action.payload.postId]]
        },
        updateComment: (state, action) => {
            const { postId, comment } = action.payload;
            if (!postId || !comment?.id) return;
            const postComments = state.items[postId];
            if (!postComments) return;
            const commentIndex = postComments.findIndex(
                (value) => value.id === comment.id
            )
            if (commentIndex !== -1) {
                postComments[commentIndex] = comment;
            }

        },
        setLikes: (state, action) => {
            state.likes[action.payload.postId] = action.payload.likes
        },
        deleteComment: (state, action) => {
            state.items[action.payload.postId] = state.items[action.payload.postId]?.filter((e) => e.id !== action.payload.commentId)
        },
        likePost: (state, action) => {
            if (action.payload.like) {
                state.likes[action.payload.postId] = [{
                    postId: action.payload.postId,
                    userId: action.payload.userId,
                    userName: action.payload.userName
                }, ...state.likes[action.payload.postId]]
            }
            else {
                state.likes[action.payload.postId] = state.likes[action.payload.postId]?.filter((e) => e.userId !== action.payload.userId)
            }
        },
        forgetComments: (state, action) => {
            state.items = {}
            state.likes = {}
        }

    },

});
export const { setComments, appendComments, insertComment, setLikes, likePost, deleteComment, updateComment, forgetComments } = commentsSlice.actions
export default commentsSlice.reducer;